<template>
  <my-case-section-core>
    <template #header>
      <div class="mb-lg mb-lg-xl">
        <p class="mb-0 small-text">
          You have already returned {{ mustReviewItems.length > 1 ? 'these items' : 'this item' }}, but we still need your {{ mustReviewItems.length > 1 ? 'reviews' : 'review' }}.
        </p>
      </div>
    </template>
    <template #body>
      <CaseItem
        v-for="(item, idx) in mustReviewItems"
        :key="item.id"
        class="p-md border-bottom"
        :class="{'border-top': idx === 0 }"
        :package-item="item"
        :show-buy-button="false"
        :show-review-button="true"/>
    </template>
  </my-case-section-core>
</template>

<script setup>
import CaseItem from '@/components/case/caseItem/CaseItem.vue'
</script>
<script>
import MyCaseSectionCore from '../common/MyCaseSectionCore'
import MyCaseMixin from '../common/MyCaseMixin'

export default {
  components: {
    MyCaseSectionCore
  },
  mixins: [MyCaseMixin]
}
</script>

<style scoped>
::v-deep(.section) {
  padding: 0;
}
::v-deep(.section.mobile) {
  padding: 0;
}
</style>